import React from 'react';
import {classes} from './PoliciesPageMainLoader.st.css';
import {SkeletonSection} from '../../../common/components/Skeleton/SkeletonSection/SkeletonSection';
import {SkeletonRow} from '../../../common/components/Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonLineWrapper} from '../../../common/components/Skeleton/SkeletonLineWrapper/SkeletonLineWrapper';

export enum PoliciesPageMainLoaderDataHook {
  Loader = 'PoliciesPageMainLoaderDataHook.Loader',
}

export const PoliciesPageMainLoader = () => {
  return (
    <div data-hook={PoliciesPageMainLoaderDataHook.Loader}>
      <SkeletonSection>
        <SkeletonRow>
          <SkeletonLineWrapper className={classes.line} />
        </SkeletonRow>
        <SkeletonRow>
          <SkeletonLineWrapper className={classes.line} />
        </SkeletonRow>
        <SkeletonRow>
          <SkeletonLineWrapper className={classes.line} />
        </SkeletonRow>
      </SkeletonSection>
    </div>
  );
};
